var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconNoBackgroundBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-location-7068098") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-5",
    transform: "translate(-106, -806)",
    fill: "#00467D",
    fillRule: "nonzero",
    stroke: "#00467D",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-location-7068098",
    transform: "translate(107, 807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00309061,16 C5.83484237,16 5.67665672,15.9204271 5.57543012,15.7844011 C4.57599979,14.4439026 2.2855228,11.3827564 1.26261765,10.0177434 C-1.9313655,5.90651224 1.33568132,-0.586527357 6.57413973,0.0425277486 C11.2977616,0.36830273 13.6104093,6.31584203 10.7434949,10.017047 C9.71389741,11.3915489 7.43814366,14.4322721 6.43068247,15.7844011 C6.32946617,15.9204236 6.17127537,16 6.00302197,16 L6.00309061,16 Z M5.92868675,1.09471948 C1.91617356,1.02398778 -0.405740481,6.24172391 2.11402788,9.35600807 C3.01224877,10.5543641 4.88107126,13.0518156 6.00316097,14.5547228 C7.1279448,13.0489603 8.98744942,10.5644973 9.88954846,9.35931614 C12.3978197,6.08728941 10.1067249,0.966749508 5.92868675,1.09454537 L5.92868675,1.09471948 Z M6.00309061,8.93031205 C2.30100108,8.86230167 2.30426147,3.35534818 6.00309061,3.29005738 C9.72062411,3.36146984 9.67841061,8.86902575 6.00309061,8.93031205 Z M4.27695523,6.10992355 C4.28233284,7.07636669 5.058555,7.85571252 6.01167059,7.85103274 C6.96418559,7.84625075 7.73298607,7.05935626 7.72973601,6.09286089 C7.72436319,5.12641774 6.94747179,4.34707192 5.99502543,4.3517517 C5.04251044,4.35653351 4.27302356,5.14342817 4.27695523,6.10992355 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconNoBackgroundBlue);
export default __webpack_public_path__ + "static/media/location-icon-no-background--blue.9edbe8f99ca12ba5fdb620aeb1813328.svg";
export { ForwardRef as ReactComponent };